import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { languageList } from "../apis/apiHandler";

export const languages = createAsyncThunk(
    "language/list",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await languageList(payload);

            if (response?.code === 200 || response?.code === 404) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const initialState = {
    loading: false,
    languageList: [],
    error: null,
    success: false,
};

const languageSlice = createSlice({
    name: "language",
    initialState,

    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(languages.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(languages.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.languageList = payload;
                state.success = true;
            })
            .addCase(languages.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
    },
});

export default languageSlice.reducer;
